/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { ExcIncreaseV1WireState } from '@interxfi/types';
import { schema } from 'normalizr';

export const EXC_INCREASE_V1_WIRE_STATE_ENTITY_NAME = 'exc.increase.v1.Wire';
export const excIncreaseV1WireStateEntity = new schema.Entity<ExcIncreaseV1WireState>(EXC_INCREASE_V1_WIRE_STATE_ENTITY_NAME, {}, { idAttribute: 'wireId' });

